import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Associate from './Associate';
import Ongoing from './Ongoing';
import History from './History';

const MentorMentoringRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/ongoing" element={<Ongoing />} />
      <Route path="/associate/" element={<Associate />} />
      <Route path="/history/" element={<History />} />
    </Routes>
  );
};

export default MentorMentoringRoutes;
